export default __webpack_public_path__ + "static/media/Dashboard_Filled_Active.304e8b31.svg";